import React, { useState } from 'react';

/**
 * CrumbAvatar - Displays Crumb's image with emoji fallback
 * Shows the cupcake PNG image if available, otherwise falls back to emoji
 */
const CrumbAvatar = ({ className = '', size = 'medium' }) => {
  const [imageError, setImageError] = useState(false);

  const handleImageError = () => {
    setImageError(true);
  };

  // Size classes for different use cases
  const sizeClasses = {
    small: 'w-6 h-6 text-lg',
    medium: 'w-8 h-8 text-2xl',
    large: 'w-12 h-12 text-3xl'
  };

  const currentSizeClasses = sizeClasses[size] || sizeClasses.medium;

  // Try to load the image first, fall back to emoji if it fails
  if (!imageError) {
    return (
      <img
        src="/assets/crumb-the-cupcake.png"
        alt="Crumb the Cupcake"
        className={`${currentSizeClasses} ${className}`}
        onError={handleImageError}
        style={{ objectFit: 'contain' }}
      />
    );
  }

  // Fallback to emoji
  return (
    <span 
      className={`${currentSizeClasses} ${className} flex items-center justify-center`}
      role="img" 
      aria-label="Crumb the Cupcake"
    >
      🧁
    </span>
  );
};

export default CrumbAvatar;
